import { h } from 'preact';

const VNode = h('div').constructor;

/** Check if the given object is a VNode */
export function isVNode(obj) {
	return obj instanceof VNode;
}


/** Get the active touch for a given event.
 *	@param {Event} e	A touch event.
 *	@returns { target, pageX, pageY }
 */
export function getTouch(e) {
	let touch = (e.changedTouches && e.changedTouches[0]) || (e.touches && e.touches[0]) || e;
	return {
		target: touch.target || e.target,
		pageX: touch.pageX|0,
		pageY: touch.pageY|0
	};
}


/** Faster version of Element#contains()
 *	@param {Element} parent
 *	@param {Element} child
 */
export function contains(parent, child) {
	do {
		if (child===parent) return true;
	} while ((child=child.parentNode));
	return false;
}

/** Fire an arbitrary event
 *	@param {Element} target		The event target
 *	@param {String} type		Any event type to fire (eg "mousedown")
 *	@param {Object} [props]		Additional properties to copy onto the custom event
 */
export function fireEvent(target, type, props) {
	let e = document.createEvent('Event');
	e.initEvent(type, true, true);
	for (let i in props) if (i!=='target') e[i] = props[i];
	target.dispatchEvent(e);
}

/** Given a HTMLElement, find all the text content from child <li> elements
 *  @param {Element} target     the parent HTMLElement which has list item children.
 *  @returns {String[]}         returns a list of text contents from the list item children.
 */
export function getListTextContent(target) {
	if (!target || !target.querySelectorAll) { return []; }
	return Array.prototype.slice.call(target.querySelectorAll('ul > li')).map(({ textContent }) => textContent);
}

/** Given a character or a character code, return true if it is alphanumeric or false otherwise
 *  @param {String|Number} char    the character or charCode to test
 *  @returns {Boolean}             returns true if the character is alphanumeric.
 */
export function isAlphanum(char) {
	if (typeof char === 'number') { char = String.fromCharCode(char); }
	return /[a-z0-9]/i.test(char);
}

/* Get the midpoint of an HTML element */
export function getElementCenter(htmlElement) {
	let { left, right } = htmlElement.getBoundingClientRect() || {};
	return (left + right)/2;
}
